// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".protocol-box[data-v-0268fac7]{box-sizing:border-box;padding:.46rem;font-size:.3rem;font-weight:400;color:#666;line-height:.46rem}p[data-v-0268fac7]{margin-bottom:.4rem}", ""]);
// Exports
module.exports = exports;
